import { render, staticRenderFns } from "./SegmentDayMeals.vue?vue&type=template&id=7fb4301a&"
import script from "./SegmentDayMeals.vue?vue&type=script&lang=js&"
export * from "./SegmentDayMeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports